// extracted by mini-css-extract-plugin
export var closeButton = "_eb-1";
export var closeX = "_eb-3";
export var container = "_eb-0";
export var image = "_eb-2";